import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const MAPPING_VIEWS = {
  [CUSTOMER_IDS.SUBARU]: [
    { id: 'front', name: 'Front' },
    { id: 'rear', name: 'Rear' },
    { id: 'interior', name: 'Interior' }
  ],
  [CUSTOMER_IDS.TME]: [
    { id: 'front', name: 'Front' },
    { id: 'rear', name: 'Rear' },
    { id: 'interior', name: 'Interior' }
  ],
  [CUSTOMER_IDS.NORDICS]: [
    { id: 'front', name: 'Front' },
    { id: 'rear', name: 'Rear' },
    { id: 'interior', name: 'Interior' }
  ]
}

export const MAPPING_TAB_INDEX_NAMES = {
  [CUSTOMER_IDS.SUBARU]: {
    VISUAL_SEARCH: 'VISUAL_SEARCH',
    MANUALS: 'MANUALS',
    VIDEOS: 'VIDEOS'
  },
  [CUSTOMER_IDS.TME]: {},
  [CUSTOMER_IDS.NORDICS]: {
    VISUAL_SEARCH: 'VISUAL_SEARCH',
    MANUALS: 'MANUALS',
    VIDEOS: 'VIDEOS'
  }
}

export const getMappingViews = customerId => MAPPING_VIEWS[customerId] || []

export const getMappingViewsMap = customerId => {
  const views = getMappingViews(customerId)
  return views.reduce((acc, item) => acc.set(item.id, item), new Map())
}
